module.exports = __webpack_public_path__ + "img/uav.9b6e26b6.svg";